import InputMoney from "@/common/components/form/CurrencyInputFormik";
import InputFormik from "@/common/components/form/InputFormik";
import TextAreaFormik from "@/common/components/form/TextAreaFormik";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { formatDate, } from "@/common/helpers/date.helpers";
import { IRenter } from "@/types/renter.type";
import { ISubscription } from "@/types/subscription.type";
import { FormikProvider, useFormik } from "formik";

type FormPropsEditSubscription = {
  subscription: ISubscription;
  renter: IRenter;
  onSubmit: (values) => Promise<{ ok: boolean, errors?: unknown[] }>;
}
export function FormEditSubscription({ subscription, onSubmit }: FormPropsEditSubscription) {

  const formik = useFormik({
    initialValues: {
      ...subscription,
      nextDueDate: formatDate(subscription.nextDueDate).split('/').reverse().join('-'),
      endDate: formatDate(subscription.endDate).split('/').reverse().join('-'),
    },
    enableReinitialize: true,
    onSubmit: async (values) => {

      const result = await onSubmit(values)
      return result
    }
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <section id="subscription-edit-form" className="space-y-4">
          <InputMoney
            name="weeklyValue"
            label="Valor"
            placeholder="Digite o valor da assinatura"
          />
          <InputFormik
            name="nextDueDate"
            label="Próximo vencimento"
            type="date"
            placeholder="Selecione a data de vencimento"
            onChange={formik.handleChange}
            value={formik.values.nextDueDate}
          />
          <InputFormik
            name="endDate"
            label="Data de término"
            type="date"
            placeholder="Selecione a data de término"
            onChange={formik.handleChange}
            value={formik.values.endDate}
          />
          <TextAreaFormik
            name="planName"
            label="Descrição"
            placeholder="Digite a descrição da assinatura"
            onChange={formik.handleChange}
            value={formik.values.planName}
          />
          <div className="flex justify-end pt-4">
            <ButtonWithLoader
              type="submit"
              isLoading={formik.isSubmitting}
            >
              Salvar Alterações
            </ButtonWithLoader>
          </div>
        </section>
      </FormikProvider>
    </form>
  )
}